<template>
  <div>
    <section-header variants="dividing" size="md" class="mt-6">
      <template slot="content">
        <heading level="2" size="md" qaid="allocatedBackorder.filtersHeading">{{ bp('filter') }}</heading>
      </template>
    </section-header>

    <form @submit.prevent="filterChanged">
      <div class="lg:flex lg:items-center">
        <div class="md:flex lg:mr-4 lg:w-3/5 xl:w-1/2">
          <form-group
            v-model="description"
            type="text"
            name="description"
            :maxlength="30"
            class="md:mr-4 md:flex-grow"
            :label="bp('text.account.savedLists.description')"
            qaid="allocatedBackorder.descriptionFilter"
          ></form-group>
          <div class="flex flex-col">
            <form-group
              type="checkbox"
              :multi-items="[{value: 'hideUnallocated', checked: hideUnallocated, displayName: bp('hideUnallocated')}]"
              class="md:flex md:items-center md:mt-1 md:mb-0"
              :label="bp('text.orders')"
              name="hide-unallocated"
              qaid="allocatedBackorder.hideUnallocatedFilter"
              @change="handleCheckboxChange"
            ></form-group>

            <form-group
              type="checkbox"
              :multi-items="[
                {
                  value: 'hideLinesWithoutComments',
                  checked: hideLinesWithoutComments,
                  displayName: bp('hideLinesWithoutComments'),
                },
              ]"
              name="hide-lines-without-comments"
              class="md:flex md:items-center md:mb-0"
              qaid="allocatedBackorder.hideLinesWithoutCommentsFilter"
              @change="handleCheckboxChange"
            ></form-group>
          </div>
        </div>

        <div class="buttons">
          <trek-button primary qaid="allocatedBackorder.applyFilters" @click="filterChanged">
            {{ bp('filter') }}
          </trek-button>
          <trek-button secondary qaid="allocatedBackorder.clearFilters" @click="clearFilters">
            {{ bp('text.clearFilters') }}
          </trek-button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import FormGroup from '@/components/FormGroup';
import SectionHeader from '@/components/SectionHeader';
import Heading from '@/components/Heading';
import TrekButton from '@/components/TrekButton';

export default {
  name: 'AllocatedBackorderHistoryFilters',
  components: {
    TrekButton,
    FormGroup,
    SectionHeader,
    Heading,
  },
  data() {
    return {
      hideUnallocated: false,
      hideLinesWithoutComments: false,
      description: '',
    };
  },
  methods: {
    filterChanged() {
      this.$emit('changed', {
        hideUnallocated: this.hideUnallocated,
        hideLinesWithoutComments: this.hideLinesWithoutComments,
        description: this.description,
      });
    },
    clearFilters() {
      this.resetFilters();
      this.filterChanged();
    },
    resetFilters() {
      this.hideUnallocated = false;
      this.hideLinesWithoutComments = false;
      this.description = '';
    },
    handleCheckboxChange() {
      if (event && event.target && event.target.value === 'hideUnallocated') {
        this.hideUnallocated = event.target.checked;
      }
      if (event && event.target && event.target.value === 'hideLinesWithoutComments') {
        this.hideLinesWithoutComments = event.target.checked;
      }
    },
  },
};
</script>
